import { Component, Input } from '@angular/core';

type BannerImages = {
  [key: string]: string;
};
@Component({
  selector: 'fgb-portal-games-banner',
  templateUrl: './portal-games-banner.component.html',
  styleUrl: './portal-games-banner.component.scss',
})
export class PortalGamesBannerComponent {
  @Input() isTriviaPage: boolean = false;
  @Input() isPollsPage: boolean = false;
  @Input() isPredictorPage: boolean = false;
  @Input() showFooter: boolean = false;
  bannerImage: BannerImages = {
    trivia: 'assets/images/games/trivia-banner.png',
    polls: 'assets/images/games/polls-banner.png',
    predictor: 'assets/images/games/predictor-banner.png',
  };
}
